import { useEffect } from 'react';

import { isFlowAvailable } from 'src/viewLayer/components/Flow/flowHelpers';
import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import type { RouteConfigRef } from 'src/viewLayer/components/Flow/types';
import type { Navigate } from 'src/types/navigate';
import { getGeoFlowId } from 'src/viewLayer/helpers/getGeoFlowId';

interface UseGeoConfigParams {
  routeConfigRef: RouteConfigRef;
  flowId: string;
  learnLang: string;
  navigate: Navigate
};

export default ({
  routeConfigRef,
  flowId,
  learnLang,
  navigate
}: UseGeoConfigParams): void => {
  useEffect(() => {
    const geoFlowId = getGeoFlowId(flowId);

    if (isFlowAvailable(geoFlowId) && geoFlowId !== flowId) {
      const newFlowPath = buildValidFlowPath({
        ...routeConfigRef,
        learnLang,
        flowId: geoFlowId
      });

      navigate(newFlowPath, { replace: true });
    };
  }, [flowId, learnLang, routeConfigRef, navigate]);
};
